
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertCircle, FileText } from 'lucide-react';

const LegalAdvisorSection: React.FC = () => {
  return (
    <>
      <Card className="border-2 border-yellow-200 bg-yellow-50 dark:bg-yellow-950/20 dark:border-yellow-900">
        <CardHeader>
          <div className="flex items-start gap-2">
            <AlertCircle className="h-5 w-5 text-yellow-600 dark:text-yellow-500 mt-0.5" />
            <div>
              <CardTitle>Legal Advisor Notice</CardTitle>
              <CardDescription className="text-yellow-700 dark:text-yellow-400">
                This tool provides general information only and is not a substitute for professional legal advice
              </CardDescription>
            </div>
          </div>
        </CardHeader>
      </Card>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card>
          <CardHeader>
            <CardTitle>Rights Administration</CardTitle>
            <CardDescription>Music licensing and publishing rights</CardDescription>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>Performance Rights</span>
              </li>
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>Mechanical Rights</span>
              </li>
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>Sync Licensing</span>
              </li>
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>Digital Rights</span>
              </li>
            </ul>
          </CardContent>
          <CardFooter>
            <Button className="w-full">Explore Resources</Button>
          </CardFooter>
        </Card>
        
        <Card>
          <CardHeader>
            <CardTitle>Contract Review</CardTitle>
            <CardDescription>Guidance on reviewing agreements</CardDescription>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>Recording Contracts</span>
              </li>
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>Publishing Deals</span>
              </li>
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>Management Agreements</span>
              </li>
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>Distribution Deals</span>
              </li>
            </ul>
          </CardContent>
          <CardFooter>
            <Button className="w-full">Get Started</Button>
          </CardFooter>
        </Card>
        
        <Card>
          <CardHeader>
            <CardTitle>Find Legal Help</CardTitle>
            <CardDescription>Connect with entertainment lawyers</CardDescription>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>Attorney Directory</span>
              </li>
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>Legal Consultations</span>
              </li>
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>Pro Bono Services</span>
              </li>
              <li className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <span>Legal Clinics</span>
              </li>
            </ul>
          </CardContent>
          <CardFooter>
            <Button className="w-full">Find Attorneys</Button>
          </CardFooter>
        </Card>
      </div>
    </>
  );
};

export default LegalAdvisorSection;
